import Vue from "vue";
import ECharts from "vue-echarts";
import colors from "vuetify/es5/util/colors";

// import ECharts modules manually to reduce bundle size
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/lines";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";

// register component to use
Vue.component("v-chart", ECharts);

// set color palette
const colorPalette = [
  // colors.yellow.darken3,
  colors.pink.darken3,
  colors.teal.darken3,
  colors.blueGrey.darken3,
  // colors.lightGreen.darken3,
  colors.red.darken3,
  colors.brown.darken3,
  colors.amber.darken3,
  colors.deepPurple.darken3,
  colors.indigo.darken3,
  colors.purple.darken3,
  colors.cyan.darken3,
  colors.deepOrange.darken3,
  colors.grey.darken3,
  colors.orange.darken3,
  colors.blue.darken3,
  colors.green.darken3,
  colors.lightBlue.darken3,
  colors.lime.darken3
];

ECharts.registerTheme("material", {
  color: colorPalette,
  graph: {
    color: colorPalette
  },
  textStyle: {}
});
